<script setup lang="ts">
// Composant plein écran affiché pendant le chargement du scope (mode non-embed).
// Fond en dégradé, contenu centré avec indicateur de chargement.
// ================================
// IMPORTS
// ================================
</script>

<template>
    <!-- ================================ -->
    <!-- COMPOSANT PRINCIPAL -->
    <!-- ================================ -->
    <div
        class="splash-screen fixed inset-0 z-[100] flex flex-col items-center justify-center min-h-screen min-w-full"
        :style="{
            background: 'linear-gradient(243deg, #edf4fe 0%, #eff3f8 100%)',
        }"
    >
        <div class="flex flex-col items-center gap-6">
            <BaseProgressSpinner
                style="width: 50px; height: 50px"
                stroke-width="4"
            />
        </div>
    </div>
</template>
